import type {NextPage} from 'next'
import React, {useEffect} from "react";
import {NextSeo} from "next-seo";
import Helper from "../../app/modules/Helper";
import {useDispatch} from "react-redux";
import {checkCookieSearchData} from "../../actions/baseActions";
import Flights from '../../app/components/Flights/Flights';
import { capitalize } from 'lodash';
import { getCityName, getCityNameByIATA } from 'app/api/common';

interface HomeProps {
	page?: {
		title?: string;
		cityName?: string;
        headingOne?: string;
	};
    query?: string
}

const Home: NextPage<HomeProps> = (props) => {
    const { page } = props;
    console.log(props)
    const dispatch = useDispatch();
    useEffect(function (){
        checkCookieSearchData()(dispatch)
    },[])

    const descriptionWithCityName = page?.cityName ? Helper.trans('slug.h2', { cityName: page?.cityName }) : undefined;
    
    return (
        <div>
            <NextSeo
                title={props.page?.title || Helper.trans('metadata.flights.title')}
                description={descriptionWithCityName || Helper.trans('metadata.flights.description')}
                canonical={`${process.env.NEXT_PUBLIC_SITE_URL}`}
                openGraph={{
                    title: props.page?.title || Helper.trans('metadata.flights.title'),
                    description: descriptionWithCityName || Helper.trans('metadata.flights.description'),
                    site_name: process.env.NEXT_PUBLIC_SITE_NAME,
                }}
            />
            <Flights
                page={{
                    ...page,
                    headingTwo: Helper.trans('slug.h2', { cityName: page?.cityName })
                }}
                query={props.query}
            />
        </div>
    )
}
// @ts-ignore
Home.getInitialProps = async(ctx) => {
   // destcode can be either IATA code or city name (with country code, c:[code])
	const destcode = (ctx.query.destcode || ctx.query.destCode) as string;
	const slug = capitalize((ctx.query.slug as string).replaceAll('-', ' ') || '');

	let slugText = slug;
	let cityNameByIATA;

	try {
		slugText = Helper.startCase(slug);
	} catch (e) {
		console.log(e);
	}

	if (destcode) {
		try {
			if (destcode.includes(':')) {
				cityNameByIATA = await getCityName(destcode);
			} else {
				cityNameByIATA = await getCityNameByIATA(destcode);
			}

			const cityName = cityNameByIATA;
			const h1 = `${slugText}`;
            const page = { title: h1, headingOne: h1, cityName};

			return { page };
		} catch (e) {
			console.error(e);
		}
	}

	return { page: {} };
}

export default Home
